export const region = {
  GB: [
    'GB-ENG',            
    'GB-NIR',
    'GB-SCT',              
    'GB-WLS',

  ]}